
const statuses = {
    DRAFT: "DRAFT",
    PUBLISHED: "PUBLISHED"
}

export default statuses